import React, { useState, useEffect, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import QRCode from "qrcode.react";

import { openApi } from "../../services/api";

const VERDE = "#1DB25A";

const wrap = {
  minHeight: "100vh",
  background: "#0b1510",
  color: "#eaf3ee",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 20,
  fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
  boxSizing: "border-box",
};
const card = {
  width: "100%",
  maxWidth: 400,
  background: "#0f1d16",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: 20,
  padding: 28,
  textAlign: "center",
  boxShadow: "0 30px 60px -30px rgba(0,0,0,.6)",
};
const brand = { fontWeight: 800, letterSpacing: "-0.03em", fontSize: 18, marginBottom: 6 };
const qrBox = {
  background: "#fff",
  borderRadius: 16,
  padding: 16,
  width: 232,
  height: 232,
  margin: "22px auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const btn = {
  marginTop: 18,
  background: "transparent",
  color: VERDE,
  border: "1px solid rgba(29,178,90,.5)",
  borderRadius: 999,
  padding: "10px 20px",
  fontSize: 14,
  fontWeight: 700,
  cursor: "pointer",
};

const ConectarPublico = () => {
  const { token } = useParams();
  const [state, setState] = useState("loading"); // loading | qr | connected | expired
  const [qr, setQr] = useState("");
  const [name, setName] = useState("");
  const timer = useRef(null);

  const poll = useCallback(() => {
    openApi
      .request({ url: `/public/whatsapp-connect/${token}`, method: "GET" })
      .then(({ data }) => {
        setName(data.name || "");
        if (data.status === "CONNECTED") {
          setState("connected");
        } else {
          setQr(data.qrcode || "");
          setState(data.qrcode ? "qr" : "waiting");
        }
      })
      .catch((err) => {
        if (err?.response?.status === 404) setState("expired");
      });
  }, [token]);

  useEffect(() => {
    poll();
    timer.current = setInterval(() => {
      // para o poll quando conectou ou expirou
      setState((s) => {
        if (s === "connected" || s === "expired") {
          if (timer.current) clearInterval(timer.current);
          return s;
        }
        poll();
        return s;
      });
    }, 3000);
    return () => timer.current && clearInterval(timer.current);
  }, [poll]);

  const gerarOutro = () => {
    openApi
      .request({ url: `/public/whatsapp-connect/${token}/restart`, method: "POST" })
      .then(() => poll())
      .catch(() => {});
  };

  return (
    <div style={wrap}>
      <div style={card}>
        <div style={brand}>
          Zappro<span style={{ color: VERDE }}>.</span>
        </div>

        {state === "expired" && (
          <>
            <h2 style={{ fontSize: 20, margin: "18px 0 8px" }}>Link indisponível</h2>
            <p style={{ color: "rgba(234,243,238,.6)", fontSize: 14, lineHeight: 1.5 }}>
              Este link expirou ou já foi usado. Peça um novo para quem enviou.
            </p>
          </>
        )}

        {state === "connected" && (
          <>
            <div style={{ fontSize: 46, margin: "10px 0" }}>✅</div>
            <h2 style={{ fontSize: 20, margin: "6px 0 8px" }}>Conectado!</h2>
            <p style={{ color: "rgba(234,243,238,.6)", fontSize: 14 }}>
              O WhatsApp {name ? `"${name}" ` : ""}foi conectado com sucesso. Pode fechar esta página.
            </p>
          </>
        )}

        {(state === "qr" || state === "waiting" || state === "loading") && (
          <>
            <h2 style={{ fontSize: 19, margin: "16px 0 4px" }}>Conectar WhatsApp</h2>
            {name && (
              <p style={{ color: VERDE, fontSize: 13, fontWeight: 600, margin: 0 }}>{name}</p>
            )}

            <div style={qrBox}>
              {qr ? (
                <QRCode value={qr} size={200} level="M" />
              ) : (
                <span style={{ color: "#888", fontSize: 13 }}>Gerando o código…</span>
              )}
            </div>

            <ol
              style={{
                textAlign: "left",
                color: "rgba(234,243,238,.72)",
                fontSize: 13.5,
                lineHeight: 1.6,
                paddingLeft: 20,
                margin: 0,
              }}
            >
              <li>Abra o <b>WhatsApp</b> no celular</li>
              <li>Toque em <b>Aparelhos conectados</b></li>
              <li>Toque em <b>Conectar aparelho</b> e aponte para o código</li>
            </ol>

            <button style={btn} onClick={gerarOutro}>
              Gerar outro código
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ConectarPublico;
